/* ==========================================================================
   Shared chrome — navbar, splash and footer, injected into every page.
   The Shopify theme renders these server-side from sections/header.liquid and
   sections/footer.liquid; here one file stands in for both so the static pages
   never drift apart. Keep the markup identical to index.html.
   ========================================================================== */

(function () {
  'use strict';

  var SPLASH = '' +
    '<div class="splash" id="splash" aria-hidden="true">' +
      '<div class="splash-inner">' +
        '<svg class="splash-line" viewBox="0 0 720 250" preserveAspectRatio="xMidYMid meet" aria-hidden="true">' +
          '<text class="splash-lab splash-lab-start" x="14" y="196">Procrastinator</text>' +
          '<path class="splash-path" pathLength="100" d="M250,190 C312,190 340,210 396,202 C454,193 478,118 536,148 C596,179 622,74 678,96 C708,107 712,62 714,54" fill="none" stroke="#ffffff" stroke-width="1.6" stroke-linecap="round"/>' +
          '<circle class="splash-dot" cx="714" cy="54" r="6" fill="#ffffff"/>' +
          '<text class="splash-lab splash-lab-end" x="716" y="38" text-anchor="end">Hustler</text>' +
        '</svg>' +
        '<div class="splash-logo"><img src="logo_white_trim.svg" alt="RBRTH"></div>' +
      '</div>' +
    '</div>';

  var MNAV = '' +
    '<nav class="mnav" id="mnav" aria-label="Mobile">' +
      '<a href="/products/rbrth-supermints">Supermints</a>' +
      '<a href="/collections/all">Shop All</a>' +
      '<a href="/pages/founders-story">Founder\'s Story</a>' +
      '<a href="/pages/faq">FAQs</a>' +
      '<a href="/cart">Cart</a>' +
    '</nav>';

  var NAV = '' +
    '<header class="chrome">' +
      '<div class="nav-left">' +
        '<button class="hamburger" id="hamburger" type="button" aria-label="Open menu" aria-expanded="false"><span></span><span></span><span></span></button>' +
        '<a class="nav-link" href="/products/rbrth-supermints">Supermints</a>' +
        '<a class="nav-link" href="/pages/founders-story">Founder\'s Story</a>' +
        '<a class="nav-link" href="/collections/all">Shop All</a>' +
      '</div>' +
      '<a class="nav-logo" href="/" aria-label="RBRTH home"><img src="logo_white_trim.svg" alt="RBRTH" width="180" height="54"></a>' +
      '<div class="nav-right">' +
        '<a class="nav-link" href="/pages/faq">FAQs</a>' +
        '<a class="nav-link nav-icon-link" href="/search" aria-label="Search"><svg viewBox="0 0 22 22" aria-hidden="true"><circle cx="9.5" cy="9.5" r="7" fill="none" stroke="currentColor" stroke-width="1.7"/><path d="M14.8 14.8 20.5 20.5" stroke="currentColor" stroke-width="1.7"/></svg></a>' +
        '<a class="nav-link nav-icon-link" href="/account" aria-label="Account"><svg viewBox="0 0 22 22" aria-hidden="true"><circle cx="11" cy="7.5" r="3.6" fill="none" stroke="currentColor" stroke-width="1.7"/><path d="M3.8 19c1.3-3.6 4-5.4 7.2-5.4s5.9 1.8 7.2 5.4" fill="none" stroke="currentColor" stroke-width="1.7"/></svg></a>' +
        '<a class="nav-cart" id="cart-btn" href="/cart">Cart (<span data-cart-count>0</span>)</a>' +
      '</div>' +
    '</header>' +
    '<div class="progress" aria-hidden="true"><span class="progress__fill" id="progressFill"></span></div>' +
    MNAV;

  var FOOT = '' +
    '<footer class="sec sec--foot">' +
      '<div class="band">' +
        '<div class="foot glass is-glass">' +
          '<div class="foot__brand">' +
            '<img src="logo_white_trim.svg" alt="RBRTH" width="150" height="45">' +
            '<p>Clean energy for a higher you.</p>' +
          '</div>' +
          '<nav class="foot__col" aria-label="Shop"><h4>Shop</h4>' +
            '<a href="/products/rbrth-supermints">Supermints</a><a href="/collections/all">Shop all</a><a href="/#science">Science</a></nav>' +
          '<nav class="foot__col" aria-label="Help"><h4>Help</h4>' +
            '<a href="/pages/faq">FAQs</a><a href="/pages/shipping-policy">Shipping &amp; returns</a><a href="/pages/privacy-policy">Privacy</a><a href="/pages/terms-of-service">Terms</a></nav>' +
          '<div class="foot__col"><h4>Follow</h4><div class="foot__social">' +
            '<a href="#" aria-label="Instagram"><svg viewBox="0 0 24 24" aria-hidden="true"><rect x="2.5" y="2.5" width="19" height="19" rx="5.5" fill="none" stroke="currentColor" stroke-width="1.6"/><circle cx="12" cy="12" r="4.6" fill="none" stroke="currentColor" stroke-width="1.6"/><circle cx="17.6" cy="6.4" r="1.2" fill="currentColor"/></svg></a>' +
            '<a href="#" aria-label="X"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 3h4.6l5.1 6.9L18.6 3H22l-7.6 8.9L22 21h-4.6l-5.4-7.3L6.1 21H3l7.9-9.2z" fill="currentColor"/></svg></a>' +
            '<a href="#" aria-label="YouTube"><svg viewBox="0 0 24 24" aria-hidden="true"><rect x="1.5" y="5" width="21" height="14" rx="4" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="M10 9.2 15.4 12 10 14.8z" fill="currentColor"/></svg></a>' +
          '</div></div>' +
          '<p class="foot__base">&copy; 2026 RBRTH. All rights reserved. ' +
            '<span class="credit">Designed &amp; developed by ' +
              '<a href="https://kmats.in" target="_blank" rel="noopener">' +
                '<img src="img/kmatslogo.png" alt="KMATS" width="1055" height="406">' +
              '</a>' +
            '</span>' +
          '</p>' +
        '</div>' +
      '</div>' +
    '</footer>';


  var DRAWER = '' +
    '<div class="drawer" id="drawer" aria-hidden="true">' +
      '<div class="drawer__scrim" data-drawer-close></div>' +
      '<aside class="drawer__panel" role="dialog" aria-label="Cart">' +
        '<header class="drawer__head">' +
          '<h2 class="card__h">Your bag</h2>' +
          '<button class="drawer__close" type="button" data-drawer-close aria-label="Close cart">' +
            '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M1 1 19 19M19 1 1 19" stroke="currentColor" stroke-width="1.7"/></svg>' +
          '</button>' +
        '</header>' +
        '<div class="drawer__body" id="drawerBody"></div>' +
        '<footer class="drawer__foot" id="drawerFoot" hidden>' +
          '<div class="ship">' +
            '<p class="ship__text" id="drawerShipText"></p>' +
            '<div class="ship__track"><span class="ship__fill" id="drawerShipFill"></span></div>' +
          '</div>' +
          '<p class="srow srow--total"><span>Subtotal</span><b id="drawerSub"></b></p>' +
          '<button class="btn btn--red btn--lg btn--block" type="button">Checkout</button>' +
          '<a class="summary__back" href="/cart">View full cart</a>' +
        '</footer>' +
      '</aside>' +
    '</div>';

  /* index.html carries its own copies, so only inject what is missing */
  function inject() {
    var body = document.body;

    if (!document.getElementById('splash')) {
      body.insertAdjacentHTML('afterbegin', SPLASH);
    }
    if (!document.querySelector('.chrome')) {
      var splashEl = document.getElementById('splash');
      if (splashEl) splashEl.insertAdjacentHTML('afterend', NAV);
      else body.insertAdjacentHTML('afterbegin', NAV);
    }
    if (!document.getElementById('mnav')) {
      var headerEl = document.querySelector('.chrome') || document.querySelector('.progress') || body;
      headerEl.insertAdjacentHTML('afterend', MNAV);
    }
    if (!document.getElementById('drawer')) {
      body.insertAdjacentHTML('beforeend', DRAWER);
    }
    if (!document.querySelector('.sec--foot')) {
      var main = document.getElementById('main') || body;
      main.insertAdjacentHTML('beforeend', FOOT);
    }

    // mark the current page in the nav
    var currentPath = location.pathname;
    document.querySelectorAll('.nav-link[href]').forEach(function (a) {
      var href = a.getAttribute('href');
      if (href === currentPath || (currentPath !== '/' && href.length > 1 && currentPath.indexOf(href) === 0)) {
        a.classList.add('is-here');
      }
    });

    if (window.RBRTH && window.RBRTH.render) {
      window.RBRTH.render();
    }
  }

  document.addEventListener('click', function (e) {
    var burger = e.target.closest('#hamburger');
    if (burger) {
      e.preventDefault();
      var open = document.body.classList.toggle('nav-open');
      burger.setAttribute('aria-expanded', String(open));
      return;
    }
    var mnavLink = e.target.closest('#mnav a');
    if (mnavLink) {
      document.body.classList.remove('nav-open');
      var b = document.getElementById('hamburger');
      if (b) b.setAttribute('aria-expanded', 'false');
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.body.classList.contains('nav-open')) {
      document.body.classList.remove('nav-open');
      var b = document.getElementById('hamburger');
      if (b) b.setAttribute('aria-expanded', 'false');
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }
})();
